var _defs, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDna(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Dna_svg__b{fill:none;stroke:#304393;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Dna_svg__b",
    d: "M6.6 3c0 9 10.8 9 10.8 18M17.4 3c0 9-10.8 9-10.8 18M6.64 3.9h10.72M7.74 7.5h8.52M17.36 20.1H6.64M16.2 16.5H7.74"
  })));
}

export default SvgDna;


//////////////////
// WEBPACK FOOTER
// ./src/icons/Dna.svg
// module id = 865
// module chunks = 101